// import { IMG_BASE_URL } from "../Constant";
// import icons from "../report/Utils/icons";

// function LoginScrollpages() {
//   return (
//     <div className=" col-md-6 col-lg-6 col-xl-6 bg-primary px-0 d-none d-md-block rounded-start-3 ">
//       <div className=" card-body ps-5">
//         <div
//           id="carouselExampleSlidesOnly"
//           className="carousel slide"
//           data-bs-ride="carousel"
//         >
//           <div className="carousel-inner">
//             <div className="carousel-item active">
//               <img
//                 src={IMG_BASE_URL + "socialmedia/login1.png"}
//                 className="d-block pt-5 "
//                 alt="..."
//               />
//             </div>
//             <div className="carousel-item ">
//               <img
//                 src={IMG_BASE_URL + "socialmedia/login2.png"}
//                 className="d-block pt-5 "
//                 alt="..."
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// export default LoginScrollpages;
import React from "react";
import { IMG_BASE_URL } from "../Constant";

function LoginScrollpages() {
  return (
    <div className="col-md-6 col-lg-6 col-xl-6 bg-primary d-none d-md-block rounded-start-3">
      <div className="h-100 d-flex flex-column">
        {/* Logo and Brand Section */}
        {/* <div className="p-4 text-center">
          <h4 className="text-white fw-bold mb-0">DIHealth</h4>
         
        </div> */}

        {/* Main Content Area with Fixed Height Carousel */}
        <div className="flex-grow-1 position-relative">
          <div
            id="loginCarousel"
            className="carousel slide h-100"
            data-bs-ride="carousel"
            data-bs-interval="5000"
          >
            <div className="carousel-inner h-100">
              {/* Slide 1: EMR Platform */}
              <div className="carousel-item active h-100">
                <div className="container h-100 d-flex flex-column justify-content-between py-3">
                  {/* Image Container with Fixed Height */}
                  <div className="text-center mb-3" style={{ height: "230px" }}>
                    <img
                      src={IMG_BASE_URL + "socialmedia/login1.png"}
                      alt="EMR Platform"
                      style={{
                        height: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Content Below Image */}
                  <div className="bg-white bg-opacity-10 rounded-3 p-4 text-white">
                    <h3 className="fw-bold mb-3">Comprehensive EMR Solution</h3>
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="bg-white rounded-circle p-2 d-flex align-items-center justify-content-center me-3"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <i className="fas fa-file-prescription text-primary"></i>
                      </div>
                      <div>
                        <h6 className="mb-0">Compliant Prescriptions</h6>
                        <p className="mb-0 small text-white-50">
                          Generic/Branded prescriptions with NMC compliance
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        className="bg-white rounded-circle p-2 d-flex align-items-center justify-content-center me-3"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <i className="fas fa-user-md text-primary"></i>
                      </div>
                      <div>
                        <h6 className="mb-0">Multi-Specialty Support</h6>
                        <p className="mb-0 small text-white-50">
                          Designed for various medical specialties
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2: Patient Engagement */}
              <div className="carousel-item h-100">
                <div className="container h-100 d-flex flex-column justify-content-between py-3">
                  {/* Image Container with Fixed Height */}
                  <div className="text-center mb-3" style={{ height: "230px" }}>
                    <img
                      src={IMG_BASE_URL + "socialmedia/login2.png"}
                      alt="Patient Engagement"
                      style={{
                        height: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Content Below Image */}
                  <div className="bg-white bg-opacity-10 rounded-3 p-4 text-white">
                    <h3 className="fw-bold mb-3">Enhanced Patient Care</h3>
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="bg-white rounded-circle p-2 d-flex align-items-center justify-content-center me-3"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <i className="fab fa-whatsapp text-primary"></i>
                      </div>
                      <div>
                        <h6 className="mb-0">WhatsApp Integration</h6>
                        <p className="mb-0 small text-white-50">
                          Secure patient communication with masked number
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        className="bg-white rounded-circle p-2 d-flex align-items-center justify-content-center me-3"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <i className="fas fa-exchange-alt text-primary"></i>
                      </div>
                      <div>
                        <h6 className="mb-0">DDI System</h6>
                        <p className="mb-0 small text-white-50">
                          Smart alerts for medicine interactions
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            
            </div>

            {/* Carousel Indicators - Styled Dots - Fixed to include all 3 slides */}
            <div className="carousel-indicators mb-2">
              <button
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide-to="0"
                className="active"
                aria-current="true"
                aria-label="EMR Platform"
              ></button>
              <button
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide-to="1"
                aria-label="Patient Engagement"
              ></button>
           
            </div>
          </div>
        </div>

        {/* Footer Section */}
        <div className="p-3 text-center">
          <p className="text-white small mb-0">
            © 2025 DIHealth - Dhakka Innovation Health
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginScrollpages;